export const guardConfig = {
  invalidRedirectionPath: '/404',
};
